import React, { useState, useEffect } from 'react';
import  { useNavigate, useLocation } from 'react-router-dom'

import Dropzone from 'react-dropzone';

import HeaderComponent from '../components/Header.js'
import FooterComponent from '../components/Footer'


import iconCorrect from '../images/main/ic_correct.svg'
import iconInCorrect from '../images/main/ic_incorrect.svg'
import imgCorrectPic1 from '../images/main/img_correct_pic1.png'
import imgCorrectPic2 from '../images/main/img_correct_pic2.png'
import imgCorrectPic3 from '../images/main/img_correct_pic3.png'
import imgInCorrectPic1 from '../images/main/img_incorrect_pic1.png'
import imgInCorrectPic2 from '../images/main/img_incorrect_pic2.png'
import imgInCorrectPic3 from '../images/main/img_incorrect_pic3.png'

import iconUploadImage from '../images/register/ic_upload_image.svg'
import iconRemovePet from '../images/register/ic_remove_pet.svg'
import iconAddPet from '../images/register/ic_add_pet.svg'
import iconRemoveImage from '../images/register/ic_remove_image.png'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import iconAlertWarning from '../images/register/ic_alert_warning.png'

import DatePicker from 'react-date-picker'

function RegisterPage() {

  const navigate = useNavigate();
  const MySwal = withReactContent(Swal)
  const { state } = useLocation()

  
  const [ maximumDate, setMaximumDate ] = useState(getMaximumDate())
  
  const [ policyNumber, setPolicyNumber ] = useState("")
  const [ previousPolicyNumber, setPreviousPolicyNumber ] = useState("")
  const [ plateNumber, setPlateNumber ] = useState("")
  const [ isAgreement, setIsAgreement ] = useState(false)
  const [ isCheckError, setIsCheckError ] = useState(false)

  const [ isSubmiting, setIsSubmiting ] = useState(false)

  const [ showPetTotal, setShowPetTotal ] = useState(1)

  const [ pet1Type, setPet1Type ] = useState(-1)
  const [ pet1Gender, setPet1Gender ] = useState(-1)
  const [ pet1Specie, setPet1Specie ] = useState("")
  const [ pet1Name, setPet1Name ] = useState("")
  const [ pet1AgeType, setPet1AgeType ] = useState(1)
  const [ pet1AgeDOB, setPet1AgeDOB ] = useState("")
  const [ pet1AgeValue, setPet1AgeValue ] = useState("")
  const [ pet1AgeValueTimeType, setPet1AgeValueTimeType ] = useState(0)
  const [ pet1HasMicroChip, setPet1HasMicroChip ] = useState(0)
  const [ pet1MicroChipNo, setPet1MicroChipNo ] = useState("")
  const [ pet1HasPetDegree, setPet1HasPetDegree] = useState(0)
  const [ pet1DegreeNo, setPet1DegreeNo ] = useState("")
  const [ pet1DegreeCreateBy, setPet1DegreeCreateBy ] = useState("")
  const [ pet1Hospital, setPet1Hospital ] = useState("")
  const [ pet1OwnerTel, setPet1OwnerTel ] = useState("")
  const [ pet1ImageFront, setPet1ImageFront ] = useState(null)
  const [ pet1ImageFullBody, setPet1ImageFullBody ] = useState(null)

  const [ pet2Type, setPet2Type ] = useState(-1)
  const [ pet2Gender, setPet2Gender ] = useState(-1)
  const [ pet2Specie, setPet2Specie ] = useState("")
  const [ pet2Name, setPet2Name ] = useState("")
  const [ pet2AgeType, setPet2AgeType ] = useState(1)
  const [ pet2AgeDOB, setPet2AgeDOB ] = useState("")
  const [ pet2AgeValue, setPet2AgeValue ] = useState("")
  const [ pet2AgeValueTimeType, setPet2AgeValueTimeType ] = useState(0)
  const [ pet2HasMicroChip, setPet2HasMicroChip ] = useState(0)
  const [ pet2MicroChipNo, setPet2MicroChipNo ] = useState("")
  const [ pet2HasPetDegree, setPet2HasPetDegree] = useState(0)
  const [ pet2DegreeNo, setPet2DegreeNo ] = useState("")
  const [ pet2DegreeCreateBy, setPet2DegreeCreateBy ] = useState("")
  const [ pet2Hospital, setPet2Hospital ] = useState("")
  const [ pet2OwnerTel, setPet2OwnerTel ] = useState("")
  const [ pet2ImageFront, setPet2ImageFront ] = useState(null)
  const [ pet2ImageFullBody, setPet2ImageFullBody ] = useState(null)

  const [ pet1Error, setPet1Error ] = useState(getDefaultError())
  const [ pet2Error, setPet2Error ] = useState(getDefaultError())


  useEffect(() => {
    setPolicyNumber( state.policy_number )
    setPlateNumber(  state.plate_number )

    const previousPolicy = state.previous_policy;
    setPreviousPolicyNumber( previousPolicy  )

    if( previousPolicy !== ""){
      callGetPolicyApi( previousPolicy )
    }
  }, [])


  useEffect(() => {
    validateFormPet1()
    validateFormPet2()
  }, [pet1Type, pet1Gender, pet1Name, pet1Specie, pet1AgeDOB, pet1AgeValue, pet1MicroChipNo, pet1DegreeNo, pet1DegreeCreateBy, pet1OwnerTel, pet1ImageFront, pet1ImageFullBody, pet2Type, pet2Gender, pet2Name, pet2Specie, pet2AgeDOB, pet2AgeValue, pet2MicroChipNo, pet2DegreeNo, pet2DegreeCreateBy, pet2OwnerTel, pet2ImageFront, pet2ImageFullBody]);

  function gotoConfirm(){
    
    navigate(
      "/confirm",
      {
        state : {
          policy_number : policyNumber
        },
        replace: true 
      }
    )
  }

  function getDefaultError(){
    return {
      type: null,
      gender: null,
      specie: null,
      name: null,
      dob: null,
      age: null,
      microchip: null,
      degreeNo: null,
      degreeCreateBy: null,
      ownerTel: null,
      imageFront: null,
      imageFullBody: null
    }
  }

  function submit(){
    setIsAgreement(false)
    setIsCheckError(true)
    //Validate
    validateFormPet1()
    validateFormPet2()
    //IF VALIDATE SUCCESS
    if(isRegisterFormSuccess()){
      if(isSubmiting === false){
        setIsSubmiting(true)
        callInsertPetApi(getFormDataPets())
      }
    }

  }

  function getFormDataPets(){
    let formData = new FormData();

    formData.append('policy_no', policyNumber);  
    formData.append('plate_number', plateNumber);  

    // PET1
    formData.append('pet_type_1', pet1Type);  
    formData.append('pet_gender_1', pet1Gender);  
    formData.append('pet_specie_1', pet1Specie);  
    formData.append('pet_name_1', pet1Name);  
    formData.append('dob_type_1', pet1AgeType);  
    if(pet1AgeType === 1){
      formData.append('pet_dob_1', pet1AgeDOB);  
      formData.append('pet_age_1', "");  
      formData.append('pet_date_scale_1', "");  
    }
    else{
      formData.append('pet_dob_1', "");  
      formData.append('pet_age_1', pet1AgeValue);  
      formData.append('pet_date_scale_1', pet1AgeValueTimeType);  
    }
    formData.append('is_microchip_1', pet1HasMicroChip);  
    formData.append('microchip_no_1', pet1MicroChipNo);  
    formData.append('is_pet_degree_1', pet1HasPetDegree);  
    formData.append('pet_degree_no_1', pet1DegreeNo);  
    formData.append('pet_degree_create_by_1', pet1DegreeCreateBy);  
    formData.append('pet_hospital_1', pet1Hospital);  
    formData.append('owner_tel_1', pet1OwnerTel);  
    formData.append('image_front_1', pet1ImageFront[0]);  
    formData.append('image_full_body_1', pet1ImageFullBody[0]);  


    // PET2
    formData.append('pet_type_2', pet2Type);  
    formData.append('pet_gender_2', pet2Gender);  
    formData.append('pet_specie_2', pet2Specie);  
    formData.append('pet_name_2', pet2Name);  
    formData.append('dob_type_2', pet2AgeType);  
    if(pet2AgeType === 1){
      formData.append('pet_dob_2', pet2AgeDOB);  
      formData.append('pet_age_2', "");  
      formData.append('pet_date_scale_2', "");  
    }
    else{
      formData.append('pet_dob_2', "");  
      formData.append('pet_age_2', pet2AgeValue);  
      formData.append('pet_date_scale_2', pet2AgeValueTimeType);  
    }

    formData.append('is_microchip_2', pet2HasMicroChip);  
    formData.append('microchip_no_2', pet2MicroChipNo);  
    formData.append('is_pet_degree_2', pet2HasPetDegree);  
    formData.append('pet_degree_no_2', pet2DegreeNo);  
    formData.append('pet_degree_create_by_2', pet2DegreeCreateBy);  
    formData.append('pet_hospital_2', pet2Hospital);  
    formData.append('owner_tel_2', pet2OwnerTel);  
    if(pet2ImageFront !== null){
      formData.append('image_front_2', pet2ImageFront[0]);  
    }
    if(pet2ImageFullBody !== null){
      formData.append('image_full_body_2', pet2ImageFullBody[0]);  
    }
 

    return formData
  }

  function callInsertPetApi(  formData ){
  
  

  
  
      const requestOptions = {
        method: 'POST',
        body: formData,
      
      };
      fetch('https://petregister.innovation.thaivivat.co.th/api/v1/service/api/insertPets.php', requestOptions)
      .then(response => response.json())
      .then(data => validateInsertPetApi(data), (error) => {
        if (error) {
          // handle error here
          setIsSubmiting(false)
          setIsAgreement(false)
          MySwal.fire({
            icon: 'error',
            title: <p>ขออภัย</p>,
            text: error,
            confirmButtonText: '<span class="flex w-full">ตกลง</span>',
            confirmButtonColor: '#009640',
          })
        }
      });
    
  }

  function validateInsertPetApi(data ){
    if( data.data !== undefined){
      if( data.data.info === true){
        gotoConfirm()
      }
      else{
        setIsSubmiting(false)
        setIsAgreement(false)
        MySwal.fire({
          icon: 'error',
          title: <p>ขออภัย</p>,
          text: data.data.error,
          confirmButtonText: '<span class="flex w-full">ตกลง</span>',
          confirmButtonColor: '#009640',
        })
      }
    }
  }

  function callGetPolicyApi( policy ){
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(
        { 
          policy_no: policy
        }
      )
    };
  
    fetch('https://petregister.innovation.thaivivat.co.th/api/v1/service/api/getPets.php', requestOptions)
    .then(response => response.json())
    .then(data => validateGetPolicyApi(data), (error) => {
      if (error) {
        // handle error here
      }
    });
    
  } 

  function validateGetPolicyApi( data ){
    if(data.data !== undefined ){
      if(data.data.info !== null){
        const infos = data.data.info
        setShowPetTotal((infos.length > 1)? 2 : 1)
        if( infos.length >= 1 ){
          const pet1 = infos[0]
          setPet1Type(parseInt(pet1.pet_type.id))
          setPet1Gender(parseInt(pet1.pet_gender.id))
          setPet1Specie(pet1.pet_specie)
          setPet1Name(pet1.pet_name)

          setPet1AgeType(parseInt(pet1.dob_type.id))
          if(parseInt(pet1.dob_type.id) === 1){
            setPet1AgeDOB(pet1.pet_dob)
          }
          else{
            setPet1AgeValue(pet1.pet_age)
            setPet1AgeValueTimeType(parseInt(pet1.pet_date_scale.id))
          }

          setPet1HasMicroChip(parseInt(pet1.is_microchip.id))
          if(parseInt(pet1.is_microchip.id) === 1){
            setPet1MicroChipNo(pet1.microchip_no)
          }

          setPet1HasPetDegree(parseInt(pet1.is_pet_degree.id))
          if(parseInt(pet1.is_pet_degree.id) === 1){
            setPet1DegreeNo(pet1.pet_degree_no)
            setPet1DegreeCreateBy(pet1.pet_degree_create_by)
          }

          setPet1Hospital(pet1.pet_hospital)
          setPet1OwnerTel(pet1.owner_tel)

          setPet1ImageFront(null)
          setPet1ImageFullBody(null)
        }
        //check pet2
        if( infos.length === 2 ){
          const pet2 = infos[1]
          setPet2Type(parseInt(pet2.pet_type.id))
          setPet2Gender(parseInt(pet2.pet_gender.id))
          setPet2Specie(pet2.pet_specie)
          setPet2Name(pet2.pet_name)

          setPet2AgeType(parseInt(pet2.dob_type.id))
          if(parseInt(pet2.dob_type.id) === 1){
            setPet2AgeDOB(pet2.pet_dob)
          }
          else{
            setPet2AgeValue(pet2.pet_age)
            setPet2AgeValueTimeType(parseInt(pet2.pet_date_scale.id))
          }

          setPet2HasMicroChip(parseInt(pet2.is_microchip.id))
          if(parseInt(pet2.is_microchip.id) === 1){
            setPet2MicroChipNo(pet2.microchip_no)
          }

          setPet2HasPetDegree(parseInt(pet2.is_pet_degree.id))
          if(parseInt(pet2.is_pet_degree.id) === 1){
            setPet2DegreeNo(pet2.pet_degree_no)
            setPet2DegreeCreateBy(pet2.pet_degree_create_by)
          }

          setPet2Hospital(pet2.pet_hospital)
          setPet2OwnerTel(pet2.owner_tel)

          setPet2ImageFront(null)
          setPet2ImageFullBody(null)
        }
      }
    }
  }


  
  function changeAgeTypePet1( v ){
    v = parseInt(v)
    setPet1AgeType(v)
    if( v === 1){
      setPet1AgeValue("")
      setPet1AgeValueTimeType(0)
    }
    else if( v === 2){
      setPet1AgeDOB("")
    }
  }

  function changeAgeTypePet2( v ){
    v = parseInt(v)
    setPet2AgeType(v)
    if( v === 1){
      setPet2AgeValue("")
      setPet2AgeValueTimeType(0)
    }
    else if( v === 2){
      setPet2AgeDOB("")
    }
  }

  function changeMicroChipTypePet1( v ){
    v = parseInt(v)
    setPet1HasMicroChip(v)
    if( v === 0){
      setPet1MicroChipNo("")
    }
  }

  function changeMicroChipTypePet2( v ){
    v = parseInt(v)
    setPet2HasMicroChip(v)
    if( v === 0){
      setPet2MicroChipNo("")
    }
  }

  function changePetDegreeTypePet1( v ){
    v = parseInt(v)
    setPet1HasPetDegree(v)
    if( v === 0){
      setPet1DegreeNo("")
      setPet1DegreeCreateBy("")
    }
  }

  function changePetDegreeTypePet2( v ){
    v = parseInt(v)
    setPet2HasPetDegree(v)
    if( v === 0){
      setPet2DegreeNo("")
      setPet2DegreeCreateBy("")
    }
  }

  function changeOwnerTelValuePet1(event){
    if (!/[0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      setPet1OwnerTel("")
    }
    else{
      if ((event.target.value).length  <= 10){
        setPet1OwnerTel(event.target.value)
      }
      else{
        event.preventDefault(); 
      }
    }
  }

  function changeOwnerTelValuePet2(event){
    if (!/[0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      setPet2OwnerTel("")
    }
    else{
      if ((event.target.value).length  <= 10){
        setPet2OwnerTel(event.target.value)
      }
      else{
        event.preventDefault(); 
      }
    }
  }

  
  function changeAgeValuePet1(event){
    if (!/[0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined)) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      setPet1AgeValue("")
    }
    else{
      setPet1AgeValue(event.target.value)
    }
  }

  function changeAgeValuePet2(event){
    if (!/[0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null)  && (event.nativeEvent.data !== undefined)) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      setPet2AgeValue("")
    }
    else{
      setPet2AgeValue(event.target.value)
    }
  }

  function changePetSpecial(event , petNo ){
    if (!/[.A-Za-zก-ฮ-่-้-๊-๋-็ะ-ูเ-ไ-์ 0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      if(petNo === 1){
        setPet1Specie("")
      }
      else{
        setPet2Specie("")
      }
    }
    else{
      if(petNo === 1){
        setPet1Specie(event.target.value)
      }
      else{
        setPet2Specie(event.target.value)
      }
    }
  }


  function changePetName(event , petNo ){
    if (!/[.A-Za-zก-ฮ-่-้-๊-๋-็ะ-ูเ-ไ-์ 0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      if(petNo === 1){
        setPet1Name("")
      }
      else{
        setPet2Name("")
      }
    }
    else{
      if(petNo === 1){
        setPet1Name(event.target.value)
      }
      else{
        setPet2Name(event.target.value)
      }
    }
  }



  function changePetMicroship(event , petNo ){
    if (!/[.A-Za-zก-ฮ-่-้-๊-๋-็ะ-ูเ-ไ-์ 0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      if(petNo === 1){
        setPet1MicroChipNo("")
      }
      else{
        setPet2MicroChipNo("")
      }
    }
    else{
      if(petNo === 1){
        setPet1MicroChipNo(event.target.value)
      }
      else{
        setPet2MicroChipNo(event.target.value)
      }
    }
  }
  


  function changePetPetDegree(event , petNo ){
    if (!/[.A-Za-zก-ฮ-่-้-๊-๋-็ะ-ูเ-ไ-์ 0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      if(petNo === 1){
        setPet1DegreeNo("")
      }
      else{
        setPet2DegreeNo("")
      }
    }
    else{
      if(petNo === 1){
        setPet1DegreeNo(event.target.value)
      }
      else{
        setPet2DegreeNo(event.target.value)
      }
    }
  }

  function changePetPetCreateBy(event , petNo ){
    if (!/[.A-Za-zก-ฮ-่-้-๊-๋-็ะ-ูเ-ไ-์ 0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      if(petNo === 1){
        setPet1DegreeCreateBy("")
      }
      else{
        setPet2DegreeCreateBy("")
      }
    }
    else{
      if(petNo === 1){
        setPet1DegreeCreateBy(event.target.value)
      }
      else{
        setPet2DegreeCreateBy(event.target.value)
      }
    }
  }


  function changePetHospital(event , petNo ){
    if (!/[.A-Za-zก-ฮ-่-้-๊-๋-็ะ-ูเ-ไ-์ 0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      if(petNo === 1){
        setPet1Hospital("")
      }
      else{
        setPet2Hospital("")
      }
    }
    else{
      if(petNo === 1){
        setPet1Hospital(event.target.value)
      }
      else{
        setPet2Hospital(event.target.value)
      }
    }
  }



  function previewImage(file) {
    if(file != null)
    return (URL.createObjectURL(file[0]))
  }


  function addPet(){
    setShowPetTotal(2)
    //Default Error Form
    //setPet1Error(getDefaultError())
    //setPet2Error(getDefaultError())
  }

  function removePet( petNo ){
    if(petNo === 1){
      if(isPet1InputData()){
        //Warning
        showConfirmRemovePet(1)
      }
      else{
        //Remove
        clearForm(1)
        //Switch Pet 2 -> 1 ?
        switchPet2ToPet1()
        //Remove Pet 2
        clearForm(2)

        setShowPetTotal(1)
        //Default Error Form
        validateFormPet1()
        setPet2Error(getDefaultError())
      }
    }
    else if( petNo === 2){
      if(isPet2InputData()){
        //Warning
        showConfirmRemovePet(2)
      }
      else{
        //Remove
        clearForm(2)
        setShowPetTotal(1)
        //Default Error Form
        validateFormPet1()
        setPet2Error(getDefaultError())
      }
    }
    
  }


  function showConfirmRemovePet( petNo ){

    Swal.fire({
      title: 'ยืนยันการลบข้อมูล',
      html: '<div class="swal-content">คุณกำลังลบข้อมูล<br/>ต้องการดำเนินการต่อหรือไม่?</div>',
      icon: 'warning',
      iconHtml: `<img src="${iconAlertWarning}">`,
      showCancelButton: true,
      confirmButtonColor: '#009640',
      confirmButtonText: '<span class="">ตกลง</span>',
      cancelButtonText: 'ยกเลิก',
      cancelButtonColor: '#FFFFF',
      customClass: {
        popup:  'swal-content swal-contrainner',
        content : 'swal-content',
        icon: 'swal-warning-icon-content',
        title: 'swal-warning-title',
        confirmButton: 'swal-warning-confirm',
        cancelButton: 'swal-warning-cancel',
        actions: 'swal-warning-action'
      }

    }).then((result) => {
      if (result.isConfirmed) {
        if( petNo === 1){
          //Remove
          clearForm(1)
          //Switch Pet 2 -> 1 ?
          switchPet2ToPet1()
          //Remove Pet 2
          clearForm(2)
        
          setShowPetTotal(1)
          //Default Error Form
          validateFormPet1()
          setPet2Error(getDefaultError())
        }
        else if( petNo === 2){
          clearForm(2)
          setShowPetTotal(1)
          //Default Error Form
          validateFormPet1()
          setPet2Error(getDefaultError())
        }
      }
    })
  }

  function isPet1InputData(){
    if(
      pet1Type !== -1 ||
      pet1Gender !== -1 ||
      pet1Specie !== "" ||
      pet1Name !== "" ||
      ( ( pet1AgeType === 1 && pet1AgeDOB !== "" ) || ( pet1AgeType === 2 && pet1AgeValue !== "") ) ||
      ( ( pet1HasMicroChip === 1 && pet1MicroChipNo !== "" ) ) ||
      ( pet1HasPetDegree === 1 && pet1DegreeNo !== "" && pet1DegreeCreateBy !== "" ) ||
      (pet1OwnerTel !== "" && pet1OwnerTel.length === 10) ||
      pet1ImageFront !== null ||
      pet1ImageFullBody !== null
    ){
      return true
    }
    return false
  }

  function isPet2InputData(){
    if(
      pet2Type !== -1 ||
      pet2Gender !== -1 ||
      pet2Specie !== "" ||
      pet2Name !== "" ||
      ( ( pet2AgeType === 1 && pet2AgeDOB !== "" ) || ( pet2AgeType === 2 && pet2AgeValue !== "") ) ||
      ( ( pet2HasMicroChip === 1 && pet2MicroChipNo !== "" ) ) ||
      ( ( pet2HasPetDegree === 1 && pet2DegreeNo !== "" && pet2DegreeCreateBy !== "" ) ) ||
      ( pet2OwnerTel !== "" && pet2OwnerTel.length === 10) ||
      pet2ImageFront !== null ||
      pet2ImageFullBody !== null
    ){
      return true
    }
    return false
  }

  function clearForm( petNo ){

    if( petNo === 1) {
      setPet1Type(-1)
      setPet1Gender(-1)
      setPet1Specie("")
      setPet1Name("")
      setPet1AgeType(1)
      setPet1AgeDOB("")
      setPet1AgeValue("")
      setPet1AgeValueTimeType(0)
      setPet1HasMicroChip(0)
      setPet1MicroChipNo("")
      setPet1HasPetDegree(0)
      setPet1DegreeNo("")
      setPet1DegreeCreateBy("")
      setPet1Hospital("")
      setPet1OwnerTel("")
      setPet1ImageFront(null)
      setPet1ImageFullBody(null)
    }
    else {
      setPet2Type(-1)
      setPet2Gender(-1)
      setPet2Specie("")
      setPet2Name("")
      setPet2AgeType(1)
      setPet2AgeDOB("")
      setPet2AgeValue("")
      setPet2AgeValueTimeType(0)
      setPet2HasMicroChip(0)
      setPet2MicroChipNo("")
      setPet2HasPetDegree(0)
      setPet2DegreeNo("")
      setPet2DegreeCreateBy("")
      setPet2Hospital("")
      setPet2OwnerTel("")
      setPet2ImageFront(null)
      setPet2ImageFullBody(null)
    }
  }

  function switchPet2ToPet1(){
    setPet1Type(pet2Type)
    setPet1Gender(pet2Gender)
    setPet1Specie(pet2Specie)
    setPet1Name(pet2Name)
    setPet1AgeType(pet2AgeType)
    setPet1AgeDOB(pet2AgeDOB)
    setPet1AgeValue(pet2AgeValue)
    setPet1AgeValueTimeType(pet2AgeValueTimeType)
    setPet1HasMicroChip(pet2HasMicroChip)
    setPet1MicroChipNo(pet2MicroChipNo)
    setPet1HasPetDegree(pet2HasPetDegree)
    setPet1DegreeNo(pet2DegreeNo)
    setPet1DegreeCreateBy(pet2DegreeCreateBy)
    setPet1Hospital(pet2Hospital)
    setPet1OwnerTel(pet2OwnerTel)
    setPet1ImageFront(pet2ImageFront)
    setPet1ImageFullBody(pet2ImageFullBody)
  }

  function validateFormPet1(){
    setPet1Error({
        type: (pet1Type === -1),
        gender: (pet1Gender === -1),
        specie: (pet1Specie === ""),
        name: (pet1Name === ""),
        dob: (pet1AgeType === 1 && pet1AgeDOB === ""),
        age:  (pet1AgeType === 2 && pet1AgeValue === ""),
        microchip: (pet1HasMicroChip === 1 && pet1MicroChipNo === ""),
        degreeNo: (pet1HasPetDegree === 1 && ( pet1DegreeNo === "" ) ),
        degreeCreateBy: (pet1HasPetDegree === 1 && ( pet1DegreeCreateBy === ""  ) ),
        ownerTel: ( pet1OwnerTel === "" || pet1OwnerTel.length !== 10),
        imageFront: ( pet1ImageFront === null ),
        imageFullBody: ( pet1ImageFullBody === null )
    })
  }

  function validateFormPet2(){
    if(showPetTotal === 2){
      setPet2Error({
          type: (pet2Type === -1),
          gender: (pet2Gender === -1),
          specie: (pet2Specie === ""),
          name: (pet2Name === ""),
          dob: (pet2AgeType === 1 && pet2AgeDOB === ""),
          age:  (pet2AgeType === 2 && pet2AgeValue === ""),
          microchip: (pet2HasMicroChip === 1 && pet2MicroChipNo === ""),
          degreeNo: (pet2HasPetDegree === 1 && ( pet2DegreeNo === "" ) ),
          degreeCreateBy: (pet2HasPetDegree === 1 && ( pet2DegreeCreateBy === ""  ) ),
          ownerTel: ( pet2OwnerTel === "" || pet2OwnerTel.length < 10),
          imageFront: ( pet2ImageFront === null ),
          imageFullBody: ( pet2ImageFullBody === null )
      })
    }
  }

  function isRegisterFormSuccess(){
    if(showPetTotal === 1 ){
      for (const [key, value] of Object.entries(pet1Error)) {
        if(value === true || value === null){
          return false
        }
      }
    }
    else if(showPetTotal === 2 ){
      for (const [key, value] of Object.entries(pet1Error)) {
        if(value === true|| value === null){
          return false
        }
      }
      for (const [key, value] of Object.entries(pet2Error)) {
        if(value === true || value === null){
          return false
        }
      }
    }
    return true
  }

  function uploadPetImageFront( e , petNo){
    const files = e.target.files;
    if(petNo === 1){
      setPet1ImageFront(files)
    }
    else{
      setPet2ImageFront(files)
    }
  }
  function removeImagePetFront(petNo){
    if(petNo === 1){
      setPet1ImageFront(null)
    }
    else{
      setPet2ImageFront(null)
    }
  }

  function uploadPetImageFull( e , petNo){
    const files = e.target.files;
    if(petNo === 1){
      setPet1ImageFullBody(files)
    }
    else{
      setPet2ImageFullBody(files)
    }
  
  }
  function removeImagePetFullBody(petNo){
    if(petNo === 1){
      setPet1ImageFullBody(null)
    }
    else{
      setPet2ImageFullBody(null)
    }
  }
  
  function getMaximumDate(){
    const date = new Date()
    let t = (
      date.getFullYear()+"-"
      +( (date.getMonth()+1) < 10 ? ("0"+(date.getMonth()+1)) : (date.getMonth()+1) ) +"-"+
      +( (date.getDate()) < 10 ? ("0"+(date.getDate())) : (date.getDate()) ) 
    )
    return t
  }


  function toDate( dateStr ){
    if(dateStr !== "" && dateStr !== null){
      var date = new Date(dateStr)
      return date
    }
    return null
  }

  function toStringDate( date ){

    if(date !== "" && date !== null){

      const str =  date.getFullYear()+"-"+((date.getMonth()+1) < 10? ("0"+(date.getMonth()+1)) : (date.getMonth()+1)+"")+"-"+(date.getDate() < 10? "0"+date.getDate() : date.getDate()+"")
      return str
    }
    return null
  }

  return (
  <div className="w-full flex flex-wrap bg-white font-prompt">
    <HeaderComponent></HeaderComponent>
    <div className='flex flex-wrap w-full  '>
    


      <div className='flex flex-wrap w-full  pl-4 md:pl-24 pr-4 md:pr-24 mt-8 justify-center'>
          <label className='flex text-3xl md:text-2xl md:leading-8 w-full font-bold md:font-semibold text-center justify-center'>ความคุ้มครองสัตว์เลี้ยง</label>
          <label className='flex text-xl  w-full mt-2 md:font-normal md:text-xl md:leading-7 text-grey-600 text-center justify-center'>กรอกข้อมูลเพื่อรับความคุ้มครอง</label>
      </div>


      <div className='flex flex-wrap w-full'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>
            <div className='flex flex-wrap w-full pl-4 md:pl-24 pr-4 md:pr-24 lg:pr-0 lg:pl-0 mt-8 justify-center'>
                <div className='w-full border border-grey-300  rounded-md p-3 lg:p-4 bg-white'>
                  <label>เลขที่กรมธรรม์: { policyNumber }</label>
                </div>
            </div>
          </div>
      </div>

      { /* PET#1 */}
      <div className='flex flex-wrap w-full'>
        <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>
            <div className='flex flex-wrap w-full pl-4 md:pl-24 pr-4 md:pr-24  lg:pr-0 lg:pl-0 mt-4 md:mt-6  justify-center '>
                <div className={'flex flex-wrap w-full border  rounded-md p-3 lg:p-4 bg-white'}>
                  <div className='flex w-full'>
                      <div className='flex-none'>
                        <label className='w-full font-bold text-green-500 text-md'>ข้อมูลสัตว์เลี้ยง ตัวที่ 1</label>
                      </div>
                      <div className={'justify-end align-right '+( (showPetTotal === 2)? ' grow flex ' : ' hidden ') }>
                        <button onClick={ (e)=> { removePet(1) } }><img src={iconRemovePet} className='flex ' alt="" /></button>
                      </div>
                  </div>
                  

                  <label className='w-full font-medium text-black mt-6  text-sm'>ประเภทสัตว์เลี้ยง</label>
                  <select  defaultValue={-1} value={pet1Type} onChange={(e)=> { setPet1Type(parseInt(e.target.value)) }} className={'text-md w-full mt-2  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 ' + ( (pet1Error.type && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )}  placeholder='เลือกประเภทสัตว์เลี้ยง'>
                  <option value={-1} disabled>เลือกประเภทสัตว์เลี้ยง</option>
                    <option value={0}>สุนัข</option>
                    <option value={1}>แมว</option>
                  </select>
                  {
                    (pet1Error.type  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }


                  <label className='w-full font-medium text-black mt-6  text-sm'>เพศ</label>
                  <select  defaultValue={-1}  value={pet1Gender} onChange={(e)=> { setPet1Gender(parseInt(e.target.value)) }} className={'text-md w-full mt-2  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 ' + ( (pet1Error.gender  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )}  placeholder='เลือกเพศ'>
                    <option value={-1} disabled>เลือกเพศ</option>
                    <option value={0}>เพศผู้</option>
                    <option value={1}>เพศเมีย</option>
                  </select>
                  {
                    (pet1Error.gender  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                  <label className='w-full font-medium text-black mt-6  text-sm'>สายพันธุ์</label>
                  <input value={pet1Specie} onChange={ (e)=> { changePetSpecial(e, 1) }} type={'search'} className={'text-md w-full mt-2 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 ' + ( (pet1Error.specie  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )}  placeholder='ระบุชื่อสายพันธ์ุ' />
                  {
                    (pet1Error.specie  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                  <label className='w-full font-medium text-black mt-6  text-sm'>ชื่อสัตว์เลี้ยง</label>
                  <input value={pet1Name} onChange={ (e)=> { changePetName(e, 1) }} type={'search'} className={'text-md w-full mt-2 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 ' + ( (pet1Error.name  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )}  placeholder='ระบุชื่อสัตว์เลี้ยง' />
                  {
                    (pet1Error.name  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                  <label className='w-full font-medium text-black mt-6  text-sm'>อายุสัตว์เลี้ยง</label>
                  <label className='w-full text-grey-800 mt-2  text-sm'>หากคุณไม่ทราบวันเดือนปีเกิด กรุณาเลือกอายุโดยประมาณ ในช่อง 'อายุโดยประมาณ'</label>


                  <div className='flex w-full  mt-6 '>
                    <input onChange={(e)=>{ changeAgeTypePet1(e.currentTarget.value) }} type={'radio'} className='text-md  my-auto accent-green-500 hover:accent-green-500 ' name="radio-age-pet1" value={1} defaultChecked checked={ (pet1AgeType === 1 )? ' checked ' : '' }/>
                    <span className='text-md  ml-3  '>วันเกิดตามจริง</span>
                  </div>
                  {/* <input value={pet1AgeDOB} max={maximumDate} onChange={ (e)=> { setPet1AgeDOB(e.target.value) }} type={'date'} className={'text-md w-full mt-2 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 disabled:bg-grey-400 ' + ( (pet1Error.dob  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='10/10/2538' disabled={ (pet1AgeType === 1)? "" : "disabled" } /> */}
                  <DatePicker format="dd/MM/y" maxDate={toDate(maximumDate)}  value={ toDate(pet1AgeDOB) } onChange={ (value)=>{ setPet1AgeDOB(toStringDate(value)) } } className={'text-md w-full mt-2 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 disabled:bg-grey-400 ' + ( (pet1Error.dob  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='10/10/2538' disabled={ (pet1AgeType === 1)? "" : "disabled" }  />
                  {
                    (pet1Error.dob  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                  <div className='flex w-full  mt-6'>
                    <input onChange={(e)=>{ changeAgeTypePet1(e.currentTarget.value) }} type={'radio'} className='text-md my-auto accent-green-500' name="radio-age-pet1" value={2} checked={ (pet1AgeType === 2 )? ' checked ' : '' } />
                    <span className='text-md  ml-3 '>อายุโดยประมาณ</span>
                  </div>
                  <div className={'flex text-md w-full mt-2 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2    ' + (  (pet1AgeType === 1)?  ' bg-grey-400 ' : ( (pet1Error.age  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' ))}>
                    <div className='grow w-full'> 
                      <input className='w-full disabled:bg-grey-400 ' value={pet1AgeValue} onChange={ (e)=> { changeAgeValuePet1(e) }} type={'search'} placeholder='ระบุอายุโดยประมาณ'  disabled={ (pet1AgeType === 2)? "" : "disabled" }/>
                    </div>
                    <div className='flex-none'>
                      <select className='disabled:bg-grey-400 '  defaultValue={0} value={pet1AgeValueTimeType} onChange={(e)=> { setPet1AgeValueTimeType(parseInt(e.target.value)) }} disabled={ (pet1AgeType === 2)? "" : "disabled" }>
                        <option value={0}>สัปดาห์</option>
                        <option value={1}>เดือน</option>
                        <option value={2}>ปี</option>
                      </select>
                    </div>
                  </div>
                  {
                    (pet1Error.age  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }
                  

                  <label className='w-full font-medium text-black mt-6  text-sm'>ใบรับรองไมโครชิพ</label>
                  <div className='flex w-full   mt-2'>
                    <input onChange={(e)=>{ changeMicroChipTypePet1(e.currentTarget.value) }} type={'radio'} className='text-md my-auto accent-green-500' name="radio-microchip-pet1" value={0} defaultChecked checked={ (pet1HasMicroChip === 0 )? ' checked ' : '' }/>
                    <span className='text-md  ml-3  '>ไม่มี</span>
                    <input onChange={(e)=>{ changeMicroChipTypePet1(e.currentTarget.value) }} type={'radio'} className='ml-6 text-md my-auto accent-green-500 ' name="radio-microchip-pet1" value={1} checked={ (pet1HasMicroChip === 1 )? ' checked ' : '' }/>
                    <span className='text-md  ml-3  '>มี</span>
                  </div>
                  <input value={pet1MicroChipNo} onChange={ (e)=> { changePetMicroship(e, 1) }} type={'search'} className={'text-md w-full mt-2  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2  disabled:bg-grey-400 ' + ( (pet1Error.microchip  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุหมายเลขไมโครชิพ' disabled={ ( pet1HasMicroChip === 0 )? "disabled" : "" }/>
                  {
                    (pet1Error.microchip  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }


                  <label className='w-full font-medium text-black mt-6  text-sm'>ใบรับรองเพ็ดดีกรี</label>
                  <div className='flex w-full mt-2'>
                    <input onChange={(e)=>{ changePetDegreeTypePet1(e.currentTarget.value) }} type={'radio'} className='text-md accent-green-500' name="radio-petdegree-pet1" value={0} defaultChecked checked={ (pet1HasPetDegree === 0 )? ' checked ' : '' }/>
                    <span className='text-md  ml-3 '>ไม่มี</span>
                    <input onChange={(e)=>{ changePetDegreeTypePet1(e.currentTarget.value) }} type={'radio'} className='ml-6 text-md  accent-green-500' name="radio-petdegree-pet1" value={1} checked={ (pet1HasPetDegree === 1 )? ' checked ' : '' } />
                    <span className='text-md  ml-3  '>มี</span>
                  </div>
                  <input value={pet1DegreeNo} onChange={ (e)=> { changePetPetDegree(e, 1) }} type={'search'} className={'text-md w-full mt-2  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2  disabled:bg-grey-400  '+ ( (pet1Error.degreeNo  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุเลขทะเบียน' disabled={ ( pet1HasPetDegree === 0 )? "disabled" : "" }/>
                  {
                    (pet1Error.degreeNo  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }
                  <input value={pet1DegreeCreateBy} onChange={ (e)=> { changePetPetCreateBy(e, 1) }} type={'search'} className={'text-md w-full mt-2  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2  disabled:bg-grey-400  '+ ( (pet1Error.degreeCreateBy  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ออกให้โดย' disabled={ ( pet1HasPetDegree === 0 )? "disabled" : "" }/>
                  {
                    (pet1Error.degreeCreateBy  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                  <label className='w-full font-medium text-black mt-6  text-sm'>โรงพยาบาลสัตว์ที่ใช้บริการเป็นประจำ (ถ้ามี)</label>
                  <input value={pet1Hospital} onChange={ (e)=> { changePetHospital(e, 1) }} type={'search'} className='text-md w-full mt-2 border-gray-300 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2' placeholder='ระบุโรงพยาบาลสัตว์ที่ใช้บริการเป็นประจำ' />

                  <label className='w-full font-medium text-black mt-6  text-sm'>เบอร์โทรศัพท์เจ้าของสัตว์เลี้ยง</label>
                  <input value={pet1OwnerTel} onChange={ (e)=> { changeOwnerTelValuePet1(e) }} type={'search'} className={'text-md w-full mt-2 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 '+ ( (pet1Error.ownerTel  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุเบอร์โทรศัพท์เจ้าของสัตว์เลี้ยง' />
                  {
                    (pet1Error.ownerTel  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูลเบอร์โทรศัพท์ 10 หลัก</label>
                    :
                    null
                  }


                  <label className='w-full font-medium text-base text-black mt-6 leading-5 '>อัพโหลดรูปภาพสัตว์เลี้ยง</label>
                  <label className='w-full text-grey-800 mt-2 font-normal text-xs leading-4 lg:text-sm lg:leading-5 '>เพื่อความสมบูรณ์ของการสมัครและเพื่อให้เป็นประโยชน์ต่อการเคลมกรุณาแนบรูปภาพที่จำเป็นต่อไปนี้</label>


                  {/* <label className='w-full font-medium text-black mt-6  text-sm'>รูปถ่ายสัตว์เลี้ยงหน้าตรง</label> */}
                  <div  className={'flex flex-wrap w-full py-5.5 pl-3  mt-2 border rounded-md  border-dashed items-center '+ ( (pet1Error.imageFront  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )}>
                    
                    <div className='w-full'>
                      <label className=' text-black  font-normal text-xs leading-4 lg:text-sm lg:leading-5 '>รูปถ่ายสัตว์เลี้ยงหน้าตรง</label>
                      {
                        ( pet1ImageFront === null )?
                          <button className='ml-3 rounded-lg text-green-500 font-medium text-sm leading-6 border py-1.5 px-3 border-green-500 '>
                            <label>
                              อัปโหลดรูป
                              <input  className="hidden" type="file" accept="image/png, image/jpeg"  onChange={ (e )=>{ uploadPetImageFront(e , 1);  } } />
                            </label> 
                          </button>
                        :
                        null
                      }
                    </div>
                    {
                      ( pet1ImageFront !== null )?
                        <div className='w-[280px] relative'>
                          <div className='absolute top-0 right-0'>
                            <button onClick={(e)=>{ removeImagePetFront(1) }}><img src={iconRemoveImage} alt="remove_image" className='w-[24px] h-[24px]' /></button>
                          </div>
                          <div className=' top-0 left-0 pt-3'>
                            <img src={previewImage(pet1ImageFront)} alt="pet1_image_front" className='w-[280px] rounded-lg' />
                          </div>
                        </div>
                      :
                      null
                    }

                  </div>
                  {/* <Dropzone 
                    accept={'image/jpeg, image/png'}
                    maxFiles={1}
                    onDropAccepted={acceptedFiles => { 
                      setPet1ImageFront(acceptedFiles) 
                    }}>
                  {({getRootProps, getInputProps}) => (
                    <section  {...getRootProps({className: 'dropzone'})} className={' flex w-full  mt-2 border rounded-md justify-center  border-dashed items-center '+ ( (pet1Error.imageFront  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )}>
                      <div >
                        <input className='dropzone' {...getInputProps()} />
                        <div className='justify-center mt-6'>
                          <img src={iconUploadImage} className='mx-auto' alt="" />
                        </div>
                        <div className='w-full flex flex-wrap justify-center text-center'>
                          <label className='text-md mt-4'>ลากวางรูปที่คุณจะอัพโหลด</label>
                        </div>
                        <div className='w-full flex flex-wrap justify-center text-center  mb-6'>
                          <div className='w-full flex'>
                            <label className='w-full text-sm text-grey-800'>หรือ <label className='text-sm text-green-500'>เลือกจากเครื่อง</label></label>
                          </div>
                          <div className='w-full flex'>
                            <label className='w-full text-sm text-grey-800'>ไฟล์ภาพ .png , .jpeg ขนาดไม่เกิน 2MB</label>
                          </div>
                          {
                            ( pet1ImageFront !== null )?
                              <img src={ previewImage(pet1ImageFront) } className='flex w-36 rounded-lg object-contain mt-4' alt="" />
                              :
                              null
                          }
                        </div>
                        
                      </div>
                    </section>
                  )}
                  </Dropzone> */}
                  {
                    (pet1Error.imageFront  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }


                  {/* <label className='w-full font-medium text-black mt-6  text-sm'>รูปถ่ายสัตว์เลี้ยงเต็มตัว</label> */}
                  <div  className={'flex flex-wrap w-full py-5.5 pl-3  mt-2 border rounded-md  border-dashed items-center '+ ( (pet1Error.imageFullBody  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )}>
                    
                    <div className='w-full'>
                      <label className=' text-black  font-normal text-xs leading-4 lg:text-sm lg:leading-5 '>รูปถ่ายสัตว์เลี้ยงเต็มตัว</label>
                      {
                        ( pet1ImageFullBody === null )?
                          
                            <button className='ml-3 rounded-lg text-green-500 font-medium text-sm leading-6 border py-1.5 px-3 border-green-500 '>
                              <label>
                                อัปโหลดรูป
                                <input  className="hidden" type="file" accept="image/png, image/jpeg"  onChange={ (e )=>{ uploadPetImageFull(e , 1);  } } />
                              </label> 
                            </button>
                      
                        :
                        null
                      }
                    </div>
                    {
                      ( pet1ImageFullBody !== null )?
                        <div className='w-[280px] relative'>
                          <div className='absolute top-0 right-0'>
                            <button onClick={(e)=>{ removeImagePetFullBody(1) }}><img src={iconRemoveImage} alt="remove_image" className='w-[24px] h-[24px]' /></button>
                          </div>
                          <div className=' top-0 left-0 pt-3'>
                            <img src={previewImage(pet1ImageFullBody)} alt="pet1_image_front" className='w-[280px] rounded-lg' />
                          </div>
                        </div>
                      :
                      null
                    }

                  </div>
                  {/* <Dropzone 
                    accept={'image/jpeg, image/png'}
                    maxFiles={1}
                    onDropAccepted={acceptedFiles => { 
                      setPet1ImageFullBody(acceptedFiles) 
                    }}>
                  {({getRootProps, getInputProps}) => (
                    <section  {...getRootProps({className: 'dropzone'})} className={'flex w-full  mt-2 border rounded-md justify-center  border-dashed items-center '+ ( (pet1Error.imageFullBody  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )}>
                      <div >
                        <input className='dropzone' {...getInputProps()} />
                        <div className='justify-center mt-6'>
                          <img src={iconUploadImage} className='mx-auto' alt="" />
                        </div>

                        <div className='w-full flex flex-wrap justify-center text-center'>
                          <label className='text-md mt-4'>ลากวางรูปที่คุณจะอัพโหลด</label>
                        </div>
                        <div className='w-full flex flex-wrap justify-center text-center mb-6'>
                          <div className='w-full flex'>
                            <label className='w-full text-sm text-grey-800'>หรือ <label className='text-sm text-green-500'>เลือกจากเครื่อง</label></label>
                          </div>
                          <div className='w-full flex'>
                            <label className='w-full text-sm text-grey-800'>ไฟล์ภาพ .png , .jpeg ขนาดไม่เกิน 2MB</label>
                          </div>
                          {
                            ( pet1ImageFullBody !== null )?
                              <div className='flex'><img src={ previewImage(pet1ImageFullBody) } className='w-36 rounded-lg object-contain mt-4' alt="" /></div>
                              :
                              null
                          }
                        </div>
                    
                      </div>
                    </section>
                  )}
                  </Dropzone> */}
                  {
                    (pet1Error.imageFullBody  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                </div>
            </div>
        </div>
      </div>


      { /* PET#2 */}
      <div className='flex flex-wrap w-full'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>
            <div className={' flex-wrap w-full pl-4 md:pl-24 pr-4 md:pr-24  lg:pr-0 lg:pl-0  mt-4 md:mt-6 justify-center '+ ( (showPetTotal === 2)? ' flex ' : ' hidden ')}>
                <div className='flex flex-wrap w-full border border-grey-300  rounded-md p-3 lg:p-4 bg-white'>
                  <div className='flex w-full'>
                      <div className='flex-none'>
                        <label className='w-full font-bold text-green-500 text-md'>ข้อมูลสัตว์เลี้ยง ตัวที่ 2</label>
                      </div>
                      <div className='grow flex justify-end align-right'>
                        <button onClick={ (e)=> { removePet(2) } }><img src={iconRemovePet} className='flex ' alt="" /></button>
                      </div>
                  </div>
                  

                  <label className='w-full font-medium text-black mt-6  text-sm'>ประเภทสัตว์เลี้ยง</label>
                  <select defaultValue={-1}  value={pet2Type} onChange={(e)=> { setPet2Type(parseInt(e.target.value)) }} className={'text-md w-full mt-2  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 ' + ( (pet2Error.type  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='เลือกประเภทสัตว์เลี้ยง'>
                  <option value={-1} disabled>เลือกประเภทสัตว์เลี้ยง</option>
                    <option value={0}>สุนัข</option>
                    <option value={1}>แมว</option>
                  </select>
                  {
                    (pet2Error.type  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }


                  <label className='w-full font-medium text-black mt-6  text-sm'>เพศ</label>
                  <select defaultValue={-1} value={pet2Gender} onChange={(e)=> { setPet2Gender(parseInt(e.target.value)) }} className={'text-md w-full mt-2  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 ' + ( (pet2Error.gender  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='เลือกเพศ'>
                    <option value={-1} disabled>เลือกเพศ</option>
                    <option value={0}>เพศผู้</option>
                    <option value={1}>เพศเมีย</option>
                  </select>
                  {
                    (pet2Error.gender  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                  <label className='w-full font-medium text-black mt-6  text-sm'>สายพันธุ์</label>
                  <input value={pet2Specie} onChange={ (e)=> { changePetSpecial(e, 2) }} type={'search'} className={'text-md w-full mt-2  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 ' + ( (pet2Error.specie  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุชื่อสายพันธ์ุ' />
                  {
                    (pet2Error.specie  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                  <label className='w-full font-medium text-black mt-6  text-sm'>ชื่อสัตว์เลี้ยง</label>
                  <input value={pet2Name} onChange={ (e)=> { changePetName(e, 2) }} type={'search'} className={'text-md w-full mt-2 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 ' + ( (pet2Error.name  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุชื่อสัตว์เลี้ยง' />
                  {
                    (pet2Error.name  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                  <label className='w-full font-medium text-black mt-6  text-sm'>อายุสัตว์เลี้ยง</label>
                  <label className='w-full text-grey-800 mt-2  text-sm'>หากคุณไม่ทราบวันเดือนปีเกิด กรุณาเลือกอายุโดยประมาณ ในช่อง 'อายุโดยประมาณ'</label>

                  <div className='flex mt-6 w-full'>
                    <input onChange={(e)=>{ changeAgeTypePet2(e.currentTarget.value) }} type={'radio'} className='text-md my-auto accent-green-500' name="radio-age-pet2" value={1} defaultChecked checked={ (pet2AgeType === 1 )? ' checked ' : '' } />
                    <span className='text-md  ml-3  '>วันเกิดตามจริง</span>
                  </div>
                  {/* <input value={pet2AgeDOB} max={maximumDate} onChange={ (e)=> { setPet2AgeDOB(e.target.value) }} type={'date'} className={'text-md w-full mt-2 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 disabled:bg-grey-400 ' + ( (pet2Error.dob  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='10/10/2538' disabled={ (pet2AgeType === 1)? "" : "disabled" } /> */}
                  <DatePicker format="dd/MM/y" value={ toDate(pet2AgeDOB) } maxDate={toDate(maximumDate) } onChange={ (value)=>{ setPet2AgeDOB(toStringDate(value)) } } className={'text-md w-full mt-2 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 disabled:bg-grey-400 ' + ( (pet2Error.dob  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='10/10/2538' disabled={ (pet2AgeType === 1)? "" : "disabled" }  />
                  
                  {
                    (pet2Error.dob  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                  <div className='flex w-full mt-6'>
                    <input onChange={(e)=>{ changeAgeTypePet2(e.currentTarget.value) }} type={'radio'} className='text-md  accent-green-500' name="radio-age-pet2" value={2} checked={ (pet2AgeType === 2 )? ' checked ' : '' } />
                    <span className='text-md  ml-3 '>อายุโดยประมาณ</span>
                  </div>
                  <div className={'flex text-md w-full mt-2  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 ' + (  (pet2AgeType === 1)?  ' bg-grey-400 ' :  (pet2Error.age  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )}>
                    <div className='grow w-full'> 
                      <input className='w-full disabled:bg-grey-400 ' value={pet2AgeValue} onChange={ (e)=> { changeAgeValuePet2(e) }} type={'search'} placeholder='ระบุอายุโดยประมาณ'  disabled={ (pet2AgeType === 2)? "" : "disabled" }/>
                    </div>
                    <div className='flex-none'>
                      <select className='disabled:bg-grey-400' defaultValue={0} value={pet2AgeValueTimeType} onChange={(e)=> { setPet2AgeValueTimeType(parseInt(e.target.value)) }} disabled={ (pet2AgeType === 2)? "" : "disabled" }>
                        <option value={0}>สัปดาห์</option>
                        <option value={1}>เดือน</option>
                        <option value={2}>ปี</option>
                      </select>
                    </div>
                  </div>
                  {
                    (pet2Error.age  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }
                  

                  <label className='w-full font-medium text-black mt-6  text-sm'>ใบรับรองไมโครชิพ</label>
                  <div className='flex w-full mt-2'>
                    <input onChange={(e)=>{ changeMicroChipTypePet2(e.currentTarget.value) }} type={'radio'} className='text-md  accent-green-500' name="radio-microchip-pet2" value={0} defaultChecked  checked={ (pet2HasMicroChip === 0 )? ' checked ' : '' } />
                    <span className='text-md  ml-3  '>ไม่มี</span>
                    <input onChange={(e)=>{ changeMicroChipTypePet2(e.currentTarget.value) }} type={'radio'} className='ml-6 text-md  accent-green-500' name="radio-microchip-pet2" value={1} checked={ (pet2HasMicroChip === 1 )? ' checked ' : '' }  />
                    <span className='text-md  ml-3'>มี</span>
                  </div>
                  <input value={pet2MicroChipNo} onChange={ (e)=> { changePetMicroship(e, 2) }} type={'search'} className={'text-md w-full mt-2 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2  disabled:bg-grey-400  ' + ( (pet2Error.microchip  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุหมายเลขไมโครชิพ' disabled={ ( pet2HasMicroChip === 0 )? "disabled" : "" }/>
                  {
                    (pet2Error.microchip  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                  <label className='w-full font-medium text-black mt-6  text-sm'>ใบรับรองเพ็ดดีกรี</label>
                  <div className='flex w-full  mt-2'>
                    <input onChange={(e)=>{ changePetDegreeTypePet2(e.currentTarget.value) }} type={'radio'} className='text-md accent-green-500' name="radio-petdegree-pet2" value={0} defaultChecked checked={ (pet2HasPetDegree === 0 )? ' checked ' : '' } />
                    <span className='text-md  ml-3 '>ไม่มี</span>
                    <input onChange={(e)=>{ changePetDegreeTypePet2(e.currentTarget.value) }} type={'radio'} className='ml-6 text-md accent-green-500' name="radio-petdegree-pet2" value={1} checked={ (pet2HasPetDegree === 1 )? ' checked ' : '' }  />
                    <span className='text-md  ml-3 '>มี</span>
                  </div>
                  <input value={pet2DegreeNo} onChange={ (e)=> { changePetPetDegree(e, 2) }} type={'search'} className={'text-md w-full mt-2  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2  disabled:bg-grey-400  ' + ( (pet2Error.degreeNo  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุเลขทะเบียน' disabled={ ( pet2HasPetDegree === 0 )? "disabled" : "" }/>
                  {
                    (pet2Error.degreeNo  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }
                  <input value={pet2DegreeCreateBy} onChange={ (e)=> { changePetPetCreateBy(e, 2) }} type={'search'} className={'text-md w-full mt-2  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2  disabled:bg-grey-400  ' + ( (pet2Error.degreeCreateBy  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ออกให้โดย' disabled={ ( pet2HasPetDegree === 0 )? "disabled" : "" }/>
                  {
                    (pet2Error.degreeCreateBy  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                  <label className='w-full font-medium text-black mt-6  text-sm'>โรงพยาบาลสัตว์ที่ใช้บริการเป็นประจำ (ถ้ามี)</label>
                  <input value={pet2Hospital} onChange={ (e)=> { changePetHospital(e, 2) }} type={'search'} className='text-md w-full mt-2 border-gray-300 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2' placeholder='ระบุโรงพยาบาลสัตว์ที่ใช้บริการเป็นประจำ' />

                  <label className='w-full font-medium text-black mt-6  text-sm'>เบอร์โทรศัพท์เจ้าของสัตว์เลี้ยง</label>
                  <input value={pet2OwnerTel} onChange={ (e)=> { changeOwnerTelValuePet2(e) }} type={'search'} className={'text-md w-full mt-2 border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 ' + ( (pet2Error.ownerTel  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุเบอร์โทรศัพท์เจ้าของสัตว์เลี้ยง' />
                  {
                    (pet2Error.ownerTel  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูลเบอร์โทรศัพท์ 10 หลัก</label>
                    :
                    null
                  }


                  <label className='w-full font-medium text-base text-black mt-6 leading-5 '>อัพโหลดรูปภาพสัตว์เลี้ยง</label>
                  <label className='w-full text-grey-800 mt-2 font-normal text-xs leading-4 lg:text-sm lg:leading-5 '>เพื่อความสมบูรณ์ของการสมัครและเพื่อให้เป็นประโยชน์ต่อการเคลมกรุณาแนบรูปภาพที่จำเป็นต่อไปนี้</label>


                  {/* <label className='w-full font-medium text-black mt-6  text-sm'>รูปถ่ายสัตว์เลี้ยงหน้าตรง</label> */}
                  <div  className={'flex flex-wrap w-full py-5.5 pl-3  mt-2 border rounded-md  border-dashed items-center '+ ( (pet2Error.imageFront  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )}>
                    
                    <div className='w-full'>
                      <label className=' text-black  font-normal text-xs leading-4 lg:text-sm lg:leading-5 '>รูปถ่ายสัตว์เลี้ยงหน้าตรง</label>
                      {
                        ( pet2ImageFront === null )?
                          <button className='ml-3 rounded-lg text-green-500 font-medium text-sm leading-6 border py-1.5 px-3 border-green-500 '>
                            <label>
                              อัปโหลดรูป
                              <input  className="hidden" type="file" accept="image/png, image/jpeg"  onChange={ (e )=>{ uploadPetImageFront(e , 2);  } } />
                            </label> 
                          </button>
                        :
                        null
                      }
                    </div>
                    {
                      ( pet2ImageFront !== null )?
                        <div className='w-[280px] relative'>
                          <div className='absolute top-0 right-0'>
                            <button onClick={(e)=>{ removeImagePetFront(2) }}><img src={iconRemoveImage} alt="remove_image" className='w-[24px] h-[24px]' /></button>
                          </div>
                          <div className=' top-0 left-0 pt-3'>
                            <img src={previewImage(pet2ImageFront)} alt="pet1_image_front" className='w-[280px] rounded-lg' />
                          </div>
                        </div>
                      :
                      null
                    }

                  </div>
                  {/* <Dropzone 
                    accept={'image/jpeg, image/png'}
                    maxFiles={1}
                    onDropAccepted={acceptedFiles => { 
                      setPet2ImageFront(acceptedFiles) 
                    }}>
                  {({getRootProps, getInputProps}) => (
                    <section  {...getRootProps({className: 'dropzone'})} className={'flex w-full  mt-2 border rounded-md justify-center  border-dashed items-center ' + ( (pet2Error.imageFront)  && isCheckError? ' border-red-500 ' : ' border-grey-300 ' )}>
                      <div >
                        <input className='dropzone' {...getInputProps()} />
                        <div className='justify-center mt-6'>
                          <img src={iconUploadImage} className='mx-auto' alt="" />
                        </div>
                        <div className='w-full flex flex-wrap justify-center text-center'>
                          <label className='text-md mt-4'>ลากวางรูปที่คุณจะอัพโหลด</label>
                        </div>
                        <div className='w-full flex flex-wrap justify-center text-center mb-6'>
                          <div className='w-full flex'>
                            <label className='w-full text-sm text-grey-800'>หรือ <label className='text-sm text-green-500'>เลือกจากเครื่อง</label></label>
                          </div>
                          <div className='w-full flex'>
                            <label className='w-full text-sm text-grey-800'>ไฟล์ภาพ .png , .jpeg ขนาดไม่เกิน 2MB</label>
                          </div>
                          {
                            ( pet2ImageFront !== null )?
                              <img src={ previewImage(pet2ImageFront) } className='w-36 rounded-lg object-contain mt-4' alt="" />
                              :
                              null
                          }
                        </div>
                        
                      </div>
                    </section>
                  )}
                  </Dropzone> */}
                  {
                    (pet2Error.imageFront  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }



                  {/* <label className='w-full font-medium text-black mt-6  text-sm'>รูปถ่ายสัตว์เลี้ยงเต็มตัว</label> */}
                  <div  className={'flex flex-wrap w-full py-5.5 pl-3  mt-2 border rounded-md  border-dashed items-center '+ ( (pet2Error.imageFullBody  && isCheckError)? ' border-red-500 ' : ' border-grey-300 ' )}>
                    
                    <div className='w-full'>
                      <label className=' text-black  font-normal text-xs leading-4 lg:text-sm lg:leading-5 '>รูปถ่ายสัตว์เลี้ยงเต็มตัว</label>
                      {
                        ( pet2ImageFullBody === null )?
                          
                            <button className='ml-3 rounded-lg text-green-500 font-medium text-sm leading-6 border py-1.5 px-3 border-green-500 '>
                              <label className='w-full'>
                                อัปโหลดรูป
                                <input  className="hidden" type="file" accept="image/png, image/jpeg"  onChange={ (e )=>{ uploadPetImageFull(e ,2);  } } />
                              </label> 
                            </button>
                      
                        :
                        null
                      }
                    </div>
                    {
                      ( pet2ImageFullBody !== null )?
                        <div className='w-[280px] relative'>
                          <div className='absolute top-0 right-0'>
                            <button onClick={(e)=>{ removeImagePetFullBody(2) }}><img src={iconRemoveImage} alt="remove_image" className='w-[24px] h-[24px]' /></button>
                          </div>
                          <div className=' top-0 left-0 pt-3'>
                            <img src={previewImage(pet2ImageFullBody)} alt="pet1_image_front" className='w-[280px] rounded-lg' />
                          </div>
                        </div>
                      :
                      null
                    }

                  </div>
                  {/* <Dropzone 
                    accept={'image/jpeg, image/png'}
                    maxFiles={1}
                    onDropAccepted={acceptedFiles => { 
                      setPet2ImageFullBody(acceptedFiles) 
                    }}>
                  {({getRootProps, getInputProps}) => (
                    <section  {...getRootProps({className: 'dropzone'})} className={'flex w-full  mt-2 border rounded-md justify-center  border-dashed items-center '+  ( (pet2Error.imageFullBody && isCheckError) ? ' border-red-500 ' : ' border-grey-300 ' )}>
                      <div >
                        <input className='' {...getInputProps()} />
                        <div className='justify-center mt-6'>
                          <img src={iconUploadImage} className='mx-auto' alt=""  />
                        </div>
                        <div className='w-full flex flex-wrap justify-center text-center'>
                          <label className='text-md mt-4'>ลากวางรูปที่คุณจะอัพโหลด</label>
                        </div>
                        <div className='w-full flex flex-wrap justify-center text-center mb-6'>
                          <div className='w-full flex'>
                            <label className='w-full text-sm text-grey-800'>หรือ <label className='text-sm text-green-500 '>เลือกจากเครื่อง</label></label>
                          </div>
                          <div className='w-full flex'>
                            <label className='w-full text-sm text-grey-800'>ไฟล์ภาพ .png , .jpeg ขนาดไม่เกิน 2MB</label>
                          </div>
                          {
                            ( pet2ImageFullBody !== null )?
                              <div className='flex'><img src={ previewImage(pet2ImageFullBody) } className='w-36 rounded-lg object-contain mt-4' alt="" /></div>
                              :
                              null
                          }
                        </div>
                    
                      </div>
                    </section>
                  )}
                  </Dropzone> */}
                  {
                    (pet2Error.imageFullBody  && isCheckError)?
                    <label className={'text-red-500 text-xs mt-2 font-sarabun' }>กรุณาระบุข้อมูล</label>
                    :
                    null
                  }

                </div>
            </div>
          </div>
      </div>

      {
        ( showPetTotal === 1)?
        <div className='flex flex-wrap w-full'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>
            <div className=' w-full  pl-4 md:pl-24 pr-4 md:pr-24 lg:px-24  lg:pr-0 lg:pl-0 my-4 justify-center'>
              <button onClick={addPet} className='h-[48px] flex w-full bg-green-200 justify-center rounded-lg '>
                <div className='m-2.75 my-auto '>
                  <img src={iconAddPet} alt="" className=' w-[18px] ' />
                </div>
                <div className='  my-auto  text-green-500 font-medium text-base leading-6 '>
                  เพิ่มสัตว์เลี้ยง
                </div>
                
              </button>
            </div>
          </div>
        </div>
        :
        null
      }
  

      <div className='flex flex-wrap w-full'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>
            <div className='flex flex-wrap w-full   pl-4 md:pl-24 lg:px-24 pr-4 md:pr-24   lg:pr-0 lg:pl-0  my-8 justify-center'>
              <label className='w-full text-center text-black font-medium text-lg leading-6 '>การแนบภาพถ่ายสัตว์เลี้ยง</label>
            </div>
          </div>
      </div>



      <div className='flex flex-wrap w-full  pb-10'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>  

            <div className='flex flex-wrap w-full lg:w-1/2 pl-4 md:pl-12 pr-4 md:pr-12 lg:px-12 mt-6 md:mt-6 mb-6 justify-center'>
              <div className='relative w-full md:w-534 '>

                <div className='w-full absolute  justify-center'>
                  <div className='flex  w-full z-20 justify-center'>
                    <div className='flex align-middle text-md md:text-xl font-bold bg-green-200 py-2 px-4 -mt-2 rounded-full'>คำแนะนำรูปภาพที่ถูกต้อง</div>
                  </div>
                </div>
                <div className=' pt-12 pb-8 w-full  px-6 bg-white border-2 border-green-500 rounded-md z-10 mt-3'>
                  <div className='w-full flex justify-center'>
                    <img className='w-20 h-20 md:w-120 md:h-120' src={imgCorrectPic1}   alt="icon_correct" />
                    <img className='w-20 h-20 md:w-120 md:h-120 ml-2' src={imgCorrectPic2}   alt="icon_correct" />
                    <img className='w-20 h-20 md:w-120 md:h-120 ml-2' src={imgCorrectPic3}   alt="icon_correct" />
                  </div>
                  <div className='w-full flex mt-4 flex-wrap'>
                    <div  className='flex w-full'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}  alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ภาพหน้าตรง</label>
                    </div>

                    
                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}   alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ภาพเต็มตัว</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}   alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ภาพสี</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}   alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ไม่สวมเครื่องแต่งกายหรืออุปกรณ์ใดๆ</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}   alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>เป็นภาพไม่เกิน 3 เดือน</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}   alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ไม่ถ่ายรวมกับสัตว์เลี้ยงตัวอื่น</label>
                    </div>

                  </div>
                </div>
              </div>




            </div>

            <div className='flex flex-wrap w-full  lg:w-1/2   pl-4 md:pl-12 lg:px-12 pr-4 md:pr-12 mt-6 md:mt-6 mb-6 justify-center'>
              <div className='relative w-full  md:w-534  '>

                <div className='w-full absolute  justify-center'>
                  <div className='flex  w-full z-20 justify-center'>
                    <div className='flex align-middle text-md md:text-xl font-bold bg-red-200 py-2 px-4 -mt-2 rounded-full'>คำแนะนำรูปภาพที่ไม่ควรใช้</div>
                  </div>
                </div>
                <div className=' pt-12 pb-8 lg:pb-24 w-full px-6 bg-white border-2 border-red-500 rounded-md z-10 mt-3'>
                  <div className='w-full flex justify-center'>
                    <img className='w-20 h-20 md:w-120 md:h-120 lg:w-120 lg:h-120 ' src={imgInCorrectPic1} alt="icon_incorrect" />
                    <img className='w-20 h-20 md:w-120 md:h-120 lg:w-120 lg:h-120 ml-4' src={imgInCorrectPic2} alt="icon_incorrect" />
                    <img className='w-20 h-20 md:w-120 md:h-120 lg:w-120 lg:h-120 ml-4' src={imgInCorrectPic3} alt="icon_incorrect" />
                  </div>
                  <div className='w-full flex mt-4 flex-wrap'>
                    <div  className='flex w-full'>
                      <div className='flex'>
                        <img className='my-auto' src={iconInCorrect} alt="icon_incorrect" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>เห็นสัตว์เลี้ยงเล็กเกินไป</label>
                    </div>

                    
                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconInCorrect} alt="icon_incorrect" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ใส่เสื้อผ้าเครื่องประดับ</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconInCorrect} alt="icon_incorrect" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>มีสัตว์เลี้ยงหลายตัวในภาพเดียวกัน</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconInCorrect} alt="icon_incorrect" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ไม่เห็นหน้าสัตว์เลี้ยง</label>
                    </div>

                  </div>
                </div>
              </div>



            </div>

          </div>
        </div>


        <div className='flex flex-wrap w-full'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>  
            <div className='flex flex-wrap w-full   pl-4 md:pl-24 lg:px-24 pr-4 md:pr-24  lg:pr-0 lg:pl-0  mb-6 justify-center'>
              <label className='w-full text-center text-black mt-6  font-medium text-lg leading-6 '>ยืนยันข้อมูลเจ้าของสัตว์เลี้ยง</label>
              <div className='w-full border font-sarabun mt-6 p-6 rounded-md h-80 overflow-auto bg-white'>
                <p>
                <b>ยืนยันข้อมูลเจ้าของสัตว์เลี้ยง</b><br/>
                ข้าพเจ้า ขอยืนยันว่าสัตว์เลี้ยงที่นำมา
                ลงทะเบียนเพื่อรับความคุ้มครอง เป็นสุนัข
                หรือแมวที่ถูกเลี้ยงหรือดูแลโดยมีวัตถุประสงค์เพื่อให้เป็นสัตว์เลี้ยงหรือสัตว์ที่เลี้ยงไว้เป็น
                เพื่อนโดยไม่ใช่การเลี้ยงที่มีวัตถุประสงค์เพื่อการซื้อขาย การเลี้ยงไว้เพื่อเป็นพ่อพันธุ์ แม่พันธุ์หรือวัตถุประสงค์อื่นเช่น ต่อสู้ ล่าสัตว์ แข่งขัน ค้นหาและกู้ภัย หรือสุนัขตำรวจ เป็นต้น<br/><br/>

                ข้าพเจ้าขอยืนยันว่า เป็นเจ้าของ และมี
                กรรมสิทธิ์หรือมีส่วนได้เสียในสัตว์เลี้ยง
                ที่นำมาขอรับความคุ้มครองจริงหากขณะเกิดความเสียหายข้าพเจ้าไม่สามารถพิสูจน์ถึง
                การมีกรรมสิทธิ์หรือมีส่วนได้เสียในสัตว์เลี้ยงที่นำมาขอรับความคุ้มครองนั้นข้าพเจ้า
                รับทราบว่าการขอรับความคุ้มครองของ
                ข้าพเจ้าไม่มีผลผูกพันผู้รับประกันภัยตาม
                ประมวลกฎหมายแพ่ง และพาณิชย์
                มาตรา 863 “อันสัญญาประกันภัยนั้นถ้า
                ผู้เอาประกันภัยมิได้มีส่วนได้เสียในเหตุที่
                ประกันภัยไว้ท่านว่าย่อมไม่ผูกพันคู่สัญญา
                แต่อย่างหนึ่งอย่างใด”<br/><br/>

                <b>ข้อตกลงและยอมรับ</b><br/>
                1. ข้าพเจ้าตกลงและยอมรับว่า วิธีการ
                ดำเนินการใดๆ โดยผ่านอุปกรณ์อิเล็ก
                ทรอนิกส์และ/หรือระบบอิเล็กทรอนิกส์
                ของบริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) เป็นวิธีการที่น่าเชื่อถือและ
                ยอมรับได้ระหว่างข้าพเจ้าและบริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) รวมทั้งรับรองว่าข้อมูลและ/หรือเอกสาร
                ใดๆ ที่บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) ได้รับจากข้าพเจ้าด้วยวิธีการ
                ดังกล่าวนั้น เป็นข้อมูลและ/หรือเอกสาร
                ที่เชื่อถือได้และถูกต้องแท้จริงเสมือน
                เอกสารที่เป็นลายลักษณ์อักษรทุกประการ และใช้บังคับได้ระหว่าง ข้าพเจ้า บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) และ
                ผู้ที่เกี่ยวข้อง<br/><br/>

                2. ข้าพเจ้าตกลงและยอมรับว่า การกระทำ
                ใดๆ ผ่านระบบอิเล็กทรอนิกส์ของ บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) หากได้กระทำไปโดยมีการยืนยันด้วยระบบ
                อิเล็กทรอนิกส์ของบริษัท ประกันภัย
                ไทยวิวัฒน์ จำกัด (มหาชน) ตามที่ข้าพเจ้า
                ได้แจ้งไว้กับ บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) ในขณะการแสดงเจตนา
                ขอเป็นผู้เอาประกันภัย และ/ผู้ชำระค่าเบี้ย
                ประกันภัยนั้น ให้ถือว่าถูกต้องสมบูรณ์
                และผูกพันข้าพเจ้า โดยข้าพเจ้าไม่จำเป็น
                ต้องลงลายมือชื่อในเอกสารใดๆ ทั้งสิ้น และข้าพเจ้าตกลงรับผิดชอบการกระทำดังกล่าวเสมือนหนึ่งว่าข้าพเจ้าเป็นผู้กระทำด้วย
                ตนเอง ไม่ว่าจะเกิดขึ้นโดยข้าพเจ้าหรือ
                บุคคลใด และไม่ว่าจะด้วยเหตุใดๆ ก็ตาม<br/>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className='flex flex-wrap w-full '>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'> 
            <div className='flex flex-wrap w-full  pl-4 md:pl-24 lg:px-24 pr-4 md:pr-24  lg:pr-0 lg:pl-0 justify-center'>
              <div className='w-full flex '>
                <label class="container">
                <input 
                  checked={ (isAgreement)? "checked" : "" }
                  onChange={ (e)=> { setIsAgreement((!isAgreement)) }} 
                  type={'checkbox'} 
                  className='text-md   w-6 h-6 my-auto accent-green-500' />
                  <span class="checkmark"></span>
                  <span className=' my-auto text-base ml-4 font-sarabun not-italic font-normal leading-6  '>ข้าพเจ้ายืนยันข้อมูลข้างต้น</span>
                </label>
                
                
              </div>
            </div>
          </div>
        </div>

        <div className='flex flex-wrap w-full'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'> 
            <div className='flex flex-wrap w-full  pl-4 md:pl-24 pr-4 md:pr-24 lg:px-24  lg:pr-0 lg:pl-0 mt-6 md:mt-6 mb-20 justify-center'>
              <button  
                onClick={submit} 
                className={'w-full lg:w-96  py-2 rounded-lg font-medium text-base leading-6 '+ ( (isAgreement === false)? ' bg-grey-100 text-white ' : ' bg-green-500 text-white ') } 
                disabled={ (isAgreement === false)? "disabled" : ""} 

                >ลงทะเบียน</button>
            </div>
          </div>
        </div>

    </div>
    <FooterComponent></FooterComponent>
  </div>
  )
}

export default RegisterPage;